import { Theme } from '@mui/material/styles';

export const fieldsThird = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',

    [theme.breakpoints.up('md')]: {
        maxWidth: '50%',
    },

    [theme.breakpoints.up('lg')]: {
        maxWidth: '30%',
    },
}) as const;

export const fieldsHalf = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',

    '&.label_two-line .MuiFormLabel-asterisk':{
        lineHeight: '6px',
    },

    [theme.breakpoints.up('md')]: {
        maxWidth: '50%',
    },
}) as const;

export const fieldsHalfRow = {
    display: 'flex',
    width: '50%',
} as const;

export const fieldsFullRow = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '100%',
} as const;

export const fieldsSubjectsWrapper = (theme: Theme) => ({
    marginY: theme.spacing(3),
}) as const;

export const fieldsSubjects = (theme: Theme) => ({
    marginY: theme.spacing(2),
}) as const;

export const fieldSubjects = (theme: Theme) => ({
    marginY: theme.spacing(-3),
}) as const;

export const fieldPublishers = (theme: Theme) => ({
    '& .MuiFormControl-root': {
        flexBasis: '100%',

        [theme.breakpoints.up('md')]: {
            flexBasis: '33%',
        },
    },
}) as const;

export const fieldsClub = (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('md')]: {
        flexDirection: 'row',

        '& .MuiFormControl-root': {
            flexBasis: '50%',

            '&:first-of-type': {
                marginRight: theme.spacing(3),
            },
        },
    },
}) as const;

export const caption = (theme: Theme) => ({
    marginTop: theme.spacing(2),
}) as const;

export const error = {
    color: 'error.main',
} as const;

export const earlySchoolEducationLevel = (theme: Theme) => ({
    marginTop: theme.spacing(1),
}) as const;
